import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyConsumableStocks } from 'app/entities/pharmacy-consumable-stock/pharmacy-consumable-stock.reducer';
import { getEntities as getPharmacyConsumableBillItems } from 'app/entities/pharmacy-consumable-bill-item/pharmacy-consumable-bill-item.reducer';
import { getEntities as getPharmacyRefundBills } from 'app/entities/pharmacy-refund-bill/pharmacy-refund-bill.reducer';
import { getEntities as getPharmacyBills } from 'app/entities/pharmacy-bill/pharmacy-bill.reducer';
import { getEntities as getPharmacyReturnBills } from 'app/entities/pharmacy-return-bill/pharmacy-return-bill.reducer';
import { getEntities as getPharmacyConsumableReturnBillItems } from 'app/entities/pharmacy-consumable-return-bill-item/pharmacy-consumable-return-bill-item.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-consumable-refund-bill-item.reducer';

export const PharmacyConsumableRefundBillItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyConsumableStocks = useAppSelector(state => state.pharmacyConsumableStock.entities);
  const pharmacyConsumableBillItems = useAppSelector(state => state.pharmacyConsumableBillItem.entities);
  const pharmacyRefundBills = useAppSelector(state => state.pharmacyRefundBill.entities);
  const pharmacyBills = useAppSelector(state => state.pharmacyBill.entities);
  const pharmacyReturnBills = useAppSelector(state => state.pharmacyReturnBill.entities);
  const pharmacyConsumableReturnBillItems = useAppSelector(state => state.pharmacyConsumableReturnBillItem.entities);
  const pharmacyConsumableRefundBillItemEntity = useAppSelector(state => state.pharmacyConsumableRefundBillItem.entity);
  const loading = useAppSelector(state => state.pharmacyConsumableRefundBillItem.loading);
  const updating = useAppSelector(state => state.pharmacyConsumableRefundBillItem.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyConsumableRefundBillItem.updateSuccess);

  const handleClose = () => {
    navigate(`/pharmacy-consumable-refund-bill-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyConsumableStocks({}));
    dispatch(getPharmacyConsumableBillItems({}));
    dispatch(getPharmacyRefundBills({}));
    dispatch(getPharmacyBills({}));
    dispatch(getPharmacyReturnBills({}));
    dispatch(getPharmacyConsumableReturnBillItems({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.chargedMrp !== undefined && typeof values.chargedMrp !== 'number') {
      values.chargedMrp = Number(values.chargedMrp);
    }
    if (values.refundPaid !== undefined && typeof values.refundPaid !== 'number') {
      values.refundPaid = Number(values.refundPaid);
    }
    if (values.refundQty !== undefined && typeof values.refundQty !== 'number') {
      values.refundQty = Number(values.refundQty);
    }
    if (values.soldQty !== undefined && typeof values.soldQty !== 'number') {
      values.soldQty = Number(values.soldQty);
    }
    if (values.manufacDate !== undefined && typeof values.manufacDate !== 'number') {
      values.manufacDate = Number(values.manufacDate);
    }
    if (values.expDate !== undefined && typeof values.expDate !== 'number') {
      values.expDate = Number(values.expDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }

    const entity = {
      ...pharmacyConsumableRefundBillItemEntity,
      ...values,
      pharmacyStock: pharmacyConsumableStocks.find(it => it.id.toString() === values.pharmacyStock?.toString()),
      saleBillItem: pharmacyConsumableBillItems.find(it => it.id.toString() === values.saleBillItem?.toString()),
      refundBill: pharmacyRefundBills.find(it => it.id.toString() === values.refundBill?.toString()),
      saleBill: pharmacyBills.find(it => it.id.toString() === values.saleBill?.toString()),
      returnBill: pharmacyReturnBills.find(it => it.id.toString() === values.returnBill?.toString()),
      returnItem: pharmacyConsumableReturnBillItems.find(it => it.id.toString() === values.returnItem?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pharmacyConsumableRefundBillItemEntity,
          pharmacyStock: pharmacyConsumableRefundBillItemEntity?.pharmacyStock?.id,
          saleBillItem: pharmacyConsumableRefundBillItemEntity?.saleBillItem?.id,
          refundBill: pharmacyConsumableRefundBillItemEntity?.refundBill?.id,
          saleBill: pharmacyConsumableRefundBillItemEntity?.saleBill?.id,
          returnBill: pharmacyConsumableRefundBillItemEntity?.returnBill?.id,
          returnItem: pharmacyConsumableRefundBillItemEntity?.returnItem?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.pharmacyConsumableRefundBillItem.home.createOrEditLabel"
            data-cy="PharmacyConsumableRefundBillItemCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.home.createOrEditLabel">
              Create or edit a PharmacyConsumableRefundBillItem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-consumable-refund-bill-item-id"
                  label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.chargedMrp')}
                id="pharmacy-consumable-refund-bill-item-chargedMrp"
                name="chargedMrp"
                data-cy="chargedMrp"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.refundPaid')}
                id="pharmacy-consumable-refund-bill-item-refundPaid"
                name="refundPaid"
                data-cy="refundPaid"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.refundQty')}
                id="pharmacy-consumable-refund-bill-item-refundQty"
                name="refundQty"
                data-cy="refundQty"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.soldQty')}
                id="pharmacy-consumable-refund-bill-item-soldQty"
                name="soldQty"
                data-cy="soldQty"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.manufacDate')}
                id="pharmacy-consumable-refund-bill-item-manufacDate"
                name="manufacDate"
                data-cy="manufacDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.expDate')}
                id="pharmacy-consumable-refund-bill-item-expDate"
                name="expDate"
                data-cy="expDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.active')}
                id="pharmacy-consumable-refund-bill-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.cursor')}
                id="pharmacy-consumable-refund-bill-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.timestampentry')}
                id="pharmacy-consumable-refund-bill-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.microSec')}
                id="pharmacy-consumable-refund-bill-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.lastupdated')}
                id="pharmacy-consumable-refund-bill-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pharmacy-consumable-refund-bill-item-pharmacyStock"
                name="pharmacyStock"
                data-cy="pharmacyStock"
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.pharmacyStock')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyConsumableStocks
                  ? pharmacyConsumableStocks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-consumable-refund-bill-item-saleBillItem"
                name="saleBillItem"
                data-cy="saleBillItem"
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.saleBillItem')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyConsumableBillItems
                  ? pharmacyConsumableBillItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-consumable-refund-bill-item-refundBill"
                name="refundBill"
                data-cy="refundBill"
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.refundBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyRefundBills
                  ? pharmacyRefundBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-consumable-refund-bill-item-saleBill"
                name="saleBill"
                data-cy="saleBill"
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.saleBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyBills
                  ? pharmacyBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-consumable-refund-bill-item-returnBill"
                name="returnBill"
                data-cy="returnBill"
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.returnBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyReturnBills
                  ? pharmacyReturnBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-consumable-refund-bill-item-returnItem"
                name="returnItem"
                data-cy="returnItem"
                label={translate('tinyMedicRestApp.pharmacyConsumableRefundBillItem.returnItem')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyConsumableReturnBillItems
                  ? pharmacyConsumableReturnBillItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/pharmacy-consumable-refund-bill-item"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyConsumableRefundBillItemUpdate;
